<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>検索結果</mat-card-title>
    </mat-card-header>
    <mat-card-content>

        <div class="table-responsive" style="max-height: 500px; overflow: auto;">
            <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" style="min-width:1970px;">
                <ng-container matColumnDef="select">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef style="width: 2em;">
                        <mat-checkbox color="primary"
                            (change)="$event ? isAllSelected ? onClickAllClear() : onClickAllCheck() : null;"
                            [checked]="selection.hasValue() && isAllSelected"
                            [indeterminate]="selection.hasValue() && !isAllSelected">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row; let i = index" class="text-center">
                        <mat-checkbox color="primary" (change)="$event ? (selection.toggle(row)) : null;"
                            [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="kyoten">
                    <th mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 160px; max-width: 315px;">拠点</th>
                    <td mat-cell *matCellDef="let row; let i = index">
                        <mat-select autocomplete="off" [(ngModel)]="row.base.codeValue"
                            [ngModelOptions]="{standalone: true}" class="disabled-select-color"
                            style="max-width: 315px;">
                            <mat-option></mat-option>
                            <mat-option *ngFor="let type of kyotenList"
                                [value]="type.value">{{type.viewValue}}</mat-option>
                        </mat-select>
                    </td>
                </ng-container>
                <ng-container matColumnDef="claimYmt">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-left" *matHeaderCellDef
                        style="min-width: 75px;">請求年月
                    </th>
                    <td mat-cell *matCellDef="let row">{{row.claimYmt | dateYmStringSg}} </td>
                </ng-container>
                <ng-container matColumnDef="payDlineDate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-left" *matHeaderCellDef
                        style="min-width: 80px;">支払期限日
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.payDlineDate | dateString}}</td>
                </ng-container>
                <ng-container matColumnDef="supplystopBreakPlndate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 85px;">
                        供給停止<br>解約予定日</th>
                    <td mat-cell *matCellDef="let row">{{ row.supplystopBreakPlndate | dateString}}</td>
                </ng-container>
                <ng-container matColumnDef="supplystopWorkPlndate">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width: 85px;">
                        供給停止<br>作業予定日</th>
                    <td mat-cell *matCellDef="let row">{{ row.supplystopWorkPlndate | dateString}}</td>
                </ng-container>
                <ng-container matColumnDef="sougouHisougou.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-left" *matHeaderCellDef
                        style="min-width: 60px;">被総合</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        {{row.sougouHisougou.aname}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="parentChild.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-left" *matHeaderCellDef
                        style="min-width: 60px;">親／子</th>
                    <td mat-cell *matCellDef="let row">
                        {{row.parentChild.aname}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="errorStr">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-left" *matHeaderCellDef
                        style="min-width:280px;">エラー内容</th>
                    <td mat-cell *matCellDef="let row">{{row.errorStr}}</td>
                </ng-container>
                <ng-container matColumnDef="pressManagementdivision.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-left" *matHeaderCellDef
                        style="min-width:95px;">督促管理区分
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.pressManagementdivision.aname}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="areaTrade.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width:65px;">
                        地区<br>（営業）</th>
                    <td mat-cell *matCellDef="let row">
                        {{row.areaTrade.aname}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="payCtrNo">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-left" *matHeaderCellDef
                        style="min-width:120px;">支払契約番号
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.payCtrNo }}</td>
                </ng-container>
                <ng-container matColumnDef="visitName">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-left" *matHeaderCellDef
                        style="min-width:85px;">請求先名
                    </th>
                    <td mat-cell *matCellDef="let row">{{ row.visitName }}</td>
                </ng-container>
                <ng-container matColumnDef="nrcptMny">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-left" *matHeaderCellDef
                        style="min-width:120px;">未入金額[円]
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-right">{{ row.nrcptMny|number }}</td>
                </ng-container>
                <ng-container matColumnDef="suppntSpno">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-left" *matHeaderCellDef
                        style="min-width:120px;">
                        供給地点特定番号</th>
                    <td mat-cell *matCellDef="let row">{{ row.suppntSpno }}</td>
                </ng-container>
                <ng-container matColumnDef="gastype.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:60px;">ガス種</th>
                    <td mat-cell *matCellDef="let row">{{ row.gastype.aname }}</td>
                </ng-container>
                <ng-container matColumnDef="supplystopResumeSts.aname">
                    <th mat-sort-header mat-header-cell class="border-bottom-double text-center" *matHeaderCellDef
                        style="min-width:95px;">
                        供給停止再開<br>ステータス</th>
                    <td mat-cell *matCellDef="let row">
                        {{row.supplystopResumeSts.aname}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="supplystopForceEonflg">
                    <th mat-sort-header mat-header-cell class="border-bottom-double" *matHeaderCellDef
                        style="min-width:60px;">強制</th>
                    <td mat-cell *matCellDef="let row" class="text-center">
                        {{row.supplystopForceEonflg === '1' ? '〇': ' '}}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsCol"
                    [style.background-color]="getBackgroudColor(row)" [class]="'clickable-mat-row'"
                    (dblclick)="onDblClickRow(row)">
                </tr>
            </table>
        </div>
        <mat-paginator #paginator1 [pageSize]="10" showFirstLastButtons></mat-paginator>

        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-card-actions class="btn_area_right">
                <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickRegist()"
                    [disabled]="!registButtonEnableCheck()">登録</button>
            </mat-card-actions>
        </div>
    </mat-card-content>
</mat-card>